import { render, staticRenderFns } from "./kanBanChart.vue?vue&type=template&id=73cd98aa&scoped=true&"
import script from "./kanBanChart.vue?vue&type=script&lang=js&"
export * from "./kanBanChart.vue?vue&type=script&lang=js&"
import style0 from "./kanBanChart.vue?vue&type=style&index=0&id=73cd98aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd98aa",
  null
  
)

export default component.exports